import { render, staticRenderFns } from "./footer-sys.vue?vue&type=template&id=0146700e&scoped=true&"
import script from "./footer-sys.vue?vue&type=script&lang=js&"
export * from "./footer-sys.vue?vue&type=script&lang=js&"
import style0 from "./footer-sys.vue?vue&type=style&index=0&id=0146700e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0146700e",
  null
  
)

export default component.exports